export default __webpack_public_path__ + "static/media/icon_image.72f16487.svg";